import { Order_By } from "@/graphql";
import { ref } from "vue";

export type ProjectListSortOption = {
  icon?: string;
  label: string;
  orderBy: {
    direction: Order_By;
    field: "area" | "buildingType" | "favorite" | "name" | "updatedAt";
  };
};

const SortOptions = ref<Array<ProjectListSortOption>>([
  {
    orderBy: { direction: Order_By.desc_nulls_last, field: "favorite" },
    label: "Favorites",
    icon: "fa-solid fa-star",
  },
  {
    orderBy: { direction: Order_By.desc_nulls_last, field: "updatedAt" },
    label: "Last Updated",
  },
  {
    orderBy: { direction: Order_By.asc_nulls_last, field: "name" },
    label: "Name",
  },
  {
    orderBy: { direction: Order_By.desc_nulls_last, field: "area" },
    label: "Total Area",
  },
  {
    orderBy: { direction: Order_By.asc_nulls_last, field: "buildingType" },
    label: "Type",
  },
]);

export default SortOptions;
